import { IError } from '@checkout/errors';
import { IPaths, RootState } from '@checkout/state';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { paymentResultFailure } from '../../../reducers/checkout';
import { Messages } from '../../presentational';
import messages from './../../../i18n/base-en';
import * as Styles from './Failure.scss';

interface IOwnProps {}

interface IConnectedProps {
  pathnames: IPaths;
  errors?: IError;
}

interface IConnectetDispatchProps {
  paymentResultFailure: typeof paymentResultFailure;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class Failure extends React.Component<Props, {}> {

  componentDidMount() {
    this.props.paymentResultFailure();
  }

  goToCheckout = () => {
    window.location.href = this.props.pathnames.checkout;
  }

  render() {
    const { errors, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <div className={Styles.failure}>
        <Messages type="error" title={formatMessage(messages.error_header)} errors={errors} onClick={this.goToCheckout} />
      </div>
    );
  }
}

export default compose<React.ComponentClass>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      errors: state.checkout.errors,
      pathnames: state.checkout.pathnames
    }),
    {
      paymentResultFailure,
    }
  ),
)(Failure);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Failure/Failure.tsx